/**
 * Interface for objects that expose a default camera point of view.
 */

/**
 * Checks if the object implements {@link HasDefaultPointOfView}.
 */
export function hasDefaultPointOfView(obj) {
  return obj?.hasDefaultPointOfView === true;
}